module.exports = __webpack_public_path__ + "img/Brises vue.f2a83def.jpg";